<template>
  <div class="rise-in max-w-xl mx-auto">
    <div class="card card-pad">
      <h1 class="page-title">Export data</h1>
      <p class="page-subtitle mb-8">
        Download a project's collected data as CSV.
      </p>

      <FormulateForm @submit="onExport">
        <FormulateInput
          v-model="project"
          type="select"
          name="project"
          label="Project"
          :options="projectOptions"
          validation="required"
        />
        <FormulateInput
          type="submit"
          :label="loading ? 'Generating…' : 'Generate CSV'"
          :disabled="loading"
        />
      </FormulateForm>

      <p
        v-if="downloaded"
        class="mt-4 text-green-700 inline-flex items-center gap-2"
      >
        <font-awesome-icon icon="check-circle" /> CSV downloaded.
      </p>
      <p v-if="error" class="text-red-600 text-sm mt-3">{{ error }}</p>
    </div>
  </div>
</template>
<!-- styles below intentionally minimal; design-system classes do the work -->

<script>
import { mapGetters } from 'vuex'
import { actionTypes, getterTypes } from 'store/patient'

export default {
  name: 'Export',
  data() {
    return { project: '', downloaded: false, error: null, loading: false }
  },
  computed: {
    ...mapGetters({ projects: getterTypes.projects }),
    projectOptions() {
      return this.projects.map(p => ({ value: p.id, label: p.name }))
    },
  },
  created() {
    this.$store.dispatch(actionTypes.loadProjects)
  },
  methods: {
    async onExport() {
      this.error = null
      this.downloaded = false
      this.loading = true
      try {
        const blob = await this.$store.dispatch(
          actionTypes.exportData,
          this.project
        )
        // Trigger a client-side download from the authenticated blob response —
        // no navigation, so no broken /exports/ URL.
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = `${this.project}_data.csv`
        document.body.appendChild(a)
        a.click()
        a.remove()
        URL.revokeObjectURL(url)
        this.downloaded = true
      } catch (e) {
        this.error = e.message || 'Export failed.'
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.brand-purple-text {
  color: #831f82;
}
</style>
